import React from 'react';

const initialState = {
  pendingRequests: 0,
  region: null,
  year: null,
  availableYears: [],
  legend: null,
  mapRenderPayload: null,
  tableApiData: null,
};

export const GlobalStateContext = React.createContext();
export const GlobalDispatchContext = React.createContext();

export const START_FETCHING = 'START_FETCHING';
export const FINISH_FETCHING = 'FINISH_FETCHING';
export const SET_REGION_FILTER = 'SET_REGION_FILTER';
export const RESET_REGION_FILTER = 'RESET_REGION_FILTER';
export const SET_TIMELINE_FILTER = 'SET_TIMELINE_FILTER';
export const RESET_TIMELINE_FILTER = 'RESET_TIMELINE_FILTER';
export const SET_AVAILABLE_YEARS = 'SET_AVAILABLE_YEARS';
export const RESET_AVAILABLE_YEARS = 'RESET_AVAILABLE_YEARS';
export const SET_LEGEND = 'SET_LEGEND';
export const RESET_LEGEND = 'RESET_LEGEND';
export const RESET_REGION_AND_TIMELINE_FILTER = 'RESET_REGION_AND_TIMELINE_FILTER';
export const SET_MAP_RENDER_PAYLOAD = 'SET_MAP_RENDER_PAYLOAD';
export const SET_TABLE_API_DATA = 'SET_TABLE_API_DATA';
export const RESET_TABLE_API_DATA = 'RESET_TABLE_API_DATA';

function reducer(state, { type, payload }) {
  switch (type) {
    case START_FETCHING: {
      return { ...state, pendingRequests: state.pendingRequests + 1 };
    }
    case FINISH_FETCHING: {
      return { ...state, pendingRequests: Math.max(0, state.pendingRequests - 1) };
    }
    case SET_REGION_FILTER: {
      return { ...state, region: payload };
    }
    case SET_TIMELINE_FILTER: {
      return { ...state, year: payload };
    }
    case SET_AVAILABLE_YEARS: {
      return { ...state, availableYears: payload };
    }
    case SET_LEGEND: {
      return { ...state, legend: payload };
    }
    case RESET_REGION_FILTER: {
      return { ...state, region: null };
    }
    case RESET_TIMELINE_FILTER: {
      return { ...state, year: null };
    }
    case RESET_REGION_AND_TIMELINE_FILTER: {
      return { ...state, region: null, year: null };
    }
    case RESET_AVAILABLE_YEARS: {
      return { ...state, availableYears: [] };
    }
    case RESET_LEGEND: {
      return { ...state, legend: null };
    }
    case SET_MAP_RENDER_PAYLOAD: {
      return { ...state, mapRenderPayload: payload };
    }
    case SET_TABLE_API_DATA: {
      return { ...state, tableApiData: payload };
    }
    case RESET_TABLE_API_DATA: {
      return { ...state, tableApiData: null };
    }
    default:
      console.error(`Unknown action type ${type}`);
      return state;
  }
}

const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  );
};

export default GlobalContextProvider;
